export enum FloorExceptionalClosingHoursQueryKeys {
  GetFloorExceptionalClosingHours = 'GetFloorExceptionalClosingHours',
  GetFloorExceptionalClosingHoursByFloorId = 'GetExceptionalOpeningHoursByFloorId',
}
